import { appConfig } from '../config/app.config';
import { BROWSER_TYPES, PLATFORMS } from '../config/constants';

// Declare InstallTrigger as a global variable
declare const InstallTrigger: any;

// Get the browser type
export const getBrowser = (): string => {
    if (
        (typeof window['opr'] !== 'undefined' && !!window['opr']['addons']) ||
        !!window['opera'] ||
        navigator.userAgent.indexOf(' OPR/') >= 0
    )
        return BROWSER_TYPES.OPERA;
    if (typeof InstallTrigger !== 'undefined') return BROWSER_TYPES.FIREFOX;
    if (/^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent)) return BROWSER_TYPES.SAFARI;
    if ((typeof window['isIE'] === 'undefined' && 'StyleMedia' in window) || /(edg\/)/i.test(navigator.userAgent))
        return BROWSER_TYPES.EDGE;
    if (typeof (navigator as any).brave !== 'undefined') {
        return BROWSER_TYPES.BRAVE;
    }
    if (/(chrome|crios)/i.test(navigator.userAgent)) return BROWSER_TYPES.CHROME;
    return BROWSER_TYPES.UNKNOWN;
};

// Get the OS name
export const getOSName = (): string => {
    if (!navigator || !navigator.userAgent) return PLATFORMS.UNKNOWN;
    else if (navigator.userAgent.toLowerCase().indexOf('win') !== -1) return PLATFORMS.WINDOWS;
    else if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1) return PLATFORMS.IPHONE;
    else if (navigator.userAgent.toLowerCase().indexOf('ipad') !== -1) return PLATFORMS.IPAD;
    else if (navigator.userAgent.toLowerCase().indexOf('ipod') !== -1) return PLATFORMS.IPHONE;
    else if (navigator.userAgent.match(/(android|linux armv7|linux armv8)/i)) return PLATFORMS.ANDROID;
    else if (navigator.userAgent.toLowerCase().indexOf('mac') !== -1) return PLATFORMS.MAC;
    else if (navigator.userAgent.toLowerCase().indexOf('linux') !== -1) return PLATFORMS.LINUX;
    return PLATFORMS.UNKNOWN;
};

// Check if the browser is Safari
export const isSafari = (): boolean => {
    const userAgent = navigator.userAgent;
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    const isIOS = /(iPad|iPhone|iPod)/g.test(userAgent);

    return isSafari || isIOS;
};

// Browser utility object
const browser = {
    name: getBrowser,
    os: getOSName,
    isSafari: isSafari,
    nameWithVersion: (): string => {
        return browser.name() + ' ' + Math.floor(browser.version());
    },
    version: (): number => {
        const data = [
                { value: 'CriOS', version: 'CriOS' },
                { value: 'Edg', version: 'Edg' },
                { value: 'Firefox', version: 'Firefox' },
                { value: 'Chrome', version: 'Chrome' },
                { value: 'Safari', version: 'Version' },
                { value: 'MSIE', version: 'MSIE' },
                { value: 'Opera', version: 'Opera' },
                { value: 'CLDC', version: 'CLDC' },
                { value: 'Mozilla', version: 'Mozilla' },
            ],
            string = [navigator.userAgent, navigator.platform, navigator.appVersion, navigator.vendor].join(' ');

        for (let i = 0; i < data.length; i++) {
            const regex = new RegExp(data[i].value, 'i');
            const match = regex.test(string);
            if (match) {
                const regexVersion = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                let matches = string.match(regexVersion);
                let version = '';
                if (matches) {
                    if (matches[1]) {
                        const versionString = matches[1];
                    }
                }
                if (matches) {
                    // @ts-expect-error: matches might be null or undefined
                    matches = (matches as RegExpMatchArray)[1].split(/[._]+/);
                    for (let j = 0; j < matches.length; j += 1) {
                        if (j === 0) {
                            version += matches[j] + '.';
                        } else {
                            version += matches[j];
                        }
                    }
                } else {
                    version = '0';
                }
                return parseFloat(version);
            }
        }
        return 0;
    },
    isSupported: (): boolean => {
        const os = browser.os().toLowerCase();
        const version = browser.version();
        const userBrowser = browser.name().toLowerCase();

        if (!appConfig.browserSupport.enable) {
            return true;
        }
        for (const br of appConfig.browserSupport.browsers) {
            if (br.browser === userBrowser && (br.os === 'all' || br.os === os) && br.version <= version) {
                return true;
            }
        }
        return false;
    },
    vendor(): 'Microsoft' | 'Apple' | 'Linux' | 'Unknown' {
        const os = browser.os();
        switch (os) {
            case PLATFORMS.WINDOWS:
                return 'Microsoft';
            case PLATFORMS.MAC:
            case PLATFORMS.IPHONE:
            case PLATFORMS.IPAD:
                return 'Apple';
            case PLATFORMS.ANDROID:
            case PLATFORMS.LINUX:
                return 'Linux';
            default:
                return 'Unknown';
        }
    },
    deviceType(): 'PC' | 'Mobile' | 'Unknown' {
        const os = browser.os();
        switch (os) {
            case PLATFORMS.WINDOWS:
            case PLATFORMS.MAC:
            case PLATFORMS.LINUX:
                return 'PC';
            case PLATFORMS.IPHONE:
            case PLATFORMS.IPAD:
            case PLATFORMS.ANDROID:
                return 'Mobile';
            default:
                return 'Unknown';
        }
    },
};

export default browser;
